<template>
	<DefaultLayout>
		<client-only>
			<div class="main-wrapper flex lg:space-x-8 mt-6 justify-between">
				<aside
					:class="{
						'w-72 hidden lg:block': true
					}"
				>
					<h4 class="font-medium text-lg mb-8">
						{{ $t("account.greeting") }}, {{ getUser?.Account?.Name }}
					</h4>
					<ul class="space-y-1 mb-8">
						<li v-for="route in accountRoutes" :key="route.path">
							<NuxtLink
								:to="localePath(route.path)"
								class="flex items-center px-3 py-2 text-gray-700 text-sm font-medium"
								active-class="bg-graycustom"
							>
								<span>{{ $t(route.titleKey) }}</span>
							</NuxtLink>
						</li>
					</ul>
					<div>
						<button
							class="flex items-center border border-gray-300 shadow-sm py-2 px-4 hover:bg-gray-50"
							@click="invokeLogout()"
						>
							<ArrowRightOnRectangleIcon class="h-5 w-5 text-gray-500" />
							<span class="ml-2 text-gray-700 text-sm font-medium">{{
								$t("account.logout")
							}}</span>
						</button>
					</div>
				</aside>
				<main class="flex-1 w-full xl:pl-26">
					<slot />
				</main>
			</div>
		</client-only>
	</DefaultLayout>
</template>

<script setup lang="ts">
import { ArrowRightOnRectangleIcon } from "@heroicons/vue/24/outline";
import { storeToRefs } from "pinia";
import DefaultLayout from "./default.vue";
import { ROUTES } from "~/utils/routes";

const { getUser } = storeToRefs(userStore());

const localePath = useLocalePath();
const cartStore = useCartStore();
const { logOut } = useNorcePwa();
const router = useRouter();

const { initLayoutData } = useLayoutInit();
await initLayoutData();

const accountRoutes = [
	{
		titleKey: "account.account_overview",
		path: ROUTES.ACCOUNT.ROOT
	},
	{
		titleKey: "account.my_profile",
		path: ROUTES.ACCOUNT.PROFILE
	},
	{
		titleKey: "account.addresses",
		path: ROUTES.ACCOUNT.ADDRESS
	},
	{
		titleKey: "account.payment_methods",
		path: ROUTES.ACCOUNT.PAYMENT
	},
	{
		titleKey: "account.orders",
		path: ROUTES.ACCOUNT.ORDER
	},
	{
		titleKey: "account.material",
		path: ROUTES.ACCOUNT.MATERIAL
	},
	{
		titleKey: "account.gallery",
		path: ROUTES.ACCOUNT.GALLERY
	}
];

const invokeLogout = async () => {
	await logOut();
	useWishlistStore().$reset();
	userStore().setUser(null);
	cartStore.$reset();
	router.push(localePath("/"));
};
</script>
